import React from 'react';
import { Button, Container, Form, Row } from 'react-bootstrap';
import { Formik, Form as FormMik } from 'formik';

import { useAuth } from '../hooks/auth';

import LiveChatLogo from '../assets/icon/LiveChatLogo.svg';

import '../css/inputBox.css';
import '../css/suporte.css';

const initialValues: any = {
  name: '',
  email: '',
  clinicName: '',
  product: '',
  question: '',
  department: '',
  terms: '',
};

const ClientArea = ({
  backgroundColor,
}: {
  backgroundColor: string;
}): JSX.Element => {
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ height: '100%', transform: 'scale(0.25)' }}
    >
      <div
        className="d-flex align-items-center justify-content-center bg-danger"
        style={{
          height: '100%',
          width: '100%',
          borderRadius: '0.68rem',
          boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
        }}
      >
        <div>
          <div className="div-main">
            <div
              className="sectionA"
              style={{ height: '36.5rem', backgroundColor }}
            >
              <img
                src={LiveChatLogo}
                className="overflow-hidden"
                style={{ width: '26rem', height: '26rem' }}
                alt="Live-Chat Logo"
              />
            </div>
            <div className="sectionB fw-bold px-lg-2 pt-lg-2 px-xxl-3 pt-xxl-3">
              <div className="sectionB-logo">
                {/* <img src={urlLogoEmpresaCliente} alt="Logo Cliente" /> */}
              </div>
              <p className="title mt-lg-1">Fale Conosco</p>
              <p className="subtitle mb-lg-1">
                Antes de prosseguirmos, por favor, nos forneça algumas
                informações sobre você
              </p>
              <Container className="p-0 form-container">
                <Row className="">
                  <Formik
                    initialValues={initialValues}
                    onSubmit={async (values, { setSubmitting, resetForm }) => {
                      setSubmitting(true);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      isSubmitting,
                    }) => (
                      <FormMik>
                        <Form.Group
                          className="pt-lg-2  inputBoxPadding"
                          controlId="name"
                        >
                          <Form.Control
                            as="input"
                            type="text"
                            placeholder="Seu nome"
                            name="name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                            className={`inputBox ${
                              touched.name && errors.name ? 'is-invalid' : ''
                            }`}
                          />
                        </Form.Group>

                        <Form.Group className="inputBoxPadding">
                          <Form.Control
                            type="email"
                            placeholder="Seu email"
                            name="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            className={`inputBox
                          ${touched.email && errors.email ? 'is-invalid' : ''}`}
                          />
                        </Form.Group>

                        <Form.Group className="inputBoxPadding">
                          <Form.Control
                            type="text"
                            align-items-center
                            justify-content-center
                            placeholder="Empresa / Cidade / Estado"
                            name="clinicName"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.clinicName}
                            className={`inputBox
                            ${
                              touched.clinicName && errors.clinicName
                                ? 'is-invalid'
                                : ''
                            }`}
                          />
                        </Form.Group>

                        <Form.Group className="inputBoxPadding">
                          <Form.Control
                            type="text"
                            placeholder="Produto / No. Contrato"
                            name="product"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.product}
                            className={`inputBox
                           ${
                             touched.product && errors.product
                               ? 'is-invalid'
                               : ''
                           }`}
                          />
                        </Form.Group>
                        <Form.Group className="inputBoxPadding">
                          <Form.Select
                            areial-label="Departamento"
                            name="department"
                            placeholder="Departamento"
                            size="sm"
                            onChange={handleChange}
                            onClick={() => {
                              // setShowAlertUserDepartament(false);
                            }}
                            onBlur={handleBlur}
                            value={values.department}
                            className={`${`inputBox ${
                              touched.department && errors.department
                                ? 'is-invalid'
                                : ''
                            }`}`}
                          >
                            <option value="0">Departamento</option>
                          </Form.Select>
                        </Form.Group>
                        <Form.Group className="inputBoxPadding">
                          <Form.Control
                            id="inputQuestion"
                            type="text"
                            as="textarea"
                            placeholder="Dúvida"
                            name="question"
                            rows={1}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.question}
                            className={`inputBox ${
                              touched.question && errors.question
                                ? 'is-invalid'
                                : ''
                            }`}
                          />
                        </Form.Group>

                        <Form.Group
                          className={
                            touched.terms && errors.terms
                              ? ''
                              : 'inputBoxPadding'
                          }
                        >
                          <Form.Check
                            type="checkbox"
                            name="terms"
                            id="terms"
                            label={
                              <label htmlFor="terms">
                                Eu li e entendi os{' '}
                                <span style={{ color: '#4397D5' }}>
                                  Termos e Condições
                                </span>
                                .
                              </label>
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.terms}
                            className={`text-checkbox ${
                              touched.terms && errors.terms ? 'is-invalid' : ''
                            }`}
                          />

                          {touched.terms && errors.terms ? (
                            <div className="invalid-feedback">
                              {errors.terms}
                            </div>
                          ) : null}
                        </Form.Group>

                        <div className="bnt-div">
                          <Button
                            className="bnt-entrar"
                            type="submit"
                            disabled={isSubmitting}
                            style={{ backgroundColor }}
                          >
                            Entrar
                          </Button>
                        </div>
                      </FormMik>
                    )}
                  </Formik>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientArea;
